import styled from '@emotion/styled';

export const InfoBox = styled('div')<{
  color?: 'yellow' | 'blue' | 'red' | 'green' | 'purple' | 'gray';
  textColor?: 'yellow' | 'blue' | 'red' | 'green' | 'purple' | 'gray';
  fullWidth?: boolean;
  margin?: 'normal' | 'dense';
}>((p) => ({
  padding: p.theme.spacing(p.margin === 'dense' ? 1 : 2),
  color: p.textColor ? p.theme.custom.colors[p.textColor].w600 : undefined,
  backgroundColor: p.theme.custom.colors[p.color || 'yellow'].w100,
  borderRadius: p.theme.custom.border.radius(),
  width: p.fullWidth ? '100%' : undefined
}));

export const InfoBoxWithAction = styled(InfoBox)<{
  color?: 'yellow' | 'blue' | 'red' | 'green' | 'gray';
}>((p) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: p.theme.spacing(2)
}));
